module.exports = __webpack_public_path__ + "static/media/GI.8bab78ca.svg";